"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bus_rdf_resolve_hypermedia_1 = require("@comunica/bus-rdf-resolve-hypermedia");
const rdf_store_stream_1 = require("rdf-store-stream");
const RdfSourceMetadata_1 = require("./RdfSourceMetadata");
/**
 * A comunica None RDF Resolve Hypermedia Actor.
 */
class ActorRdfResolveHypermediaNone extends bus_rdf_resolve_hypermedia_1.ActorRdfResolveHypermedia {
    constructor(args) {
        super(args, 'file');
    }
    async testMetadata(action) {
        return { filterFactor: 0 };
    }
    async run(action) {
        this.logInfo(action.context, `Identified as file source: ${action.url}`);
        return { source: new RdfSourceMetadata_1.RdfSourceMetadata(await rdf_store_stream_1.storeStream(action.quads)) };
    }
}
exports.ActorRdfResolveHypermediaNone = ActorRdfResolveHypermediaNone;
//# sourceMappingURL=ActorRdfResolveHypermediaNone.js.map